module.exports = __webpack_public_path__ + "static/media/paypal_img.0159fa20.svg";